import __var_0__ from './main.js';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Create a Unicode sparkline column chart.
*
* @module @stdlib/plot/sparklines/unicode/column
*
* @example
* var columnChart = require( '@stdlib/plot/sparklines/unicode/column' );
*
* var data = [ 1.0, 5.0, 3.0, 2.0, 4.0, 4.0, 3.0 ];
*
* var chart = columnChart( data );
*
* var str = chart.render();
* // returns '▁█▅▃▆▆▅'
*/

// MODULES //
var columnChart = __var_0__;


// EXPORTS //
export default columnChart;
